export interface OrganizationSettings {
  wwrPercentOff?: number;
  autoGenerateAiSummariesEnabled?: boolean;
  hiringTeamAiCreditsControlEnabled?: boolean;
  lowAiCreditNotificationsEnabled?: boolean;
  lowAiCreditNotificationThreshold?: number | null;
  zeroAiCreditNotificationsEnabled?: boolean;
  [key: string]: any;
}

export interface Organization {
  id: number;
  name: string;
  description: string | null;
  publishedJobsCount: number;
  logoMedium: string | null;
  hasLogo: boolean;
  usersCount: number;
  createdAt: string;
}

export interface CurrentOrganization extends Organization {
  websiteUrl: string;
  remoteness: string;
  stripeSubscriptionInGoodStanding: boolean;
  stripeDefaultPaymentMethodOnFile: boolean;
  stripePromoCode: string | null;
  stripeSubscriptionStatus: string | null;
  stripeSubscriptionId: string | null;
  stripeCurrentPeriodEndAt?: string;
  stripeSubscription?: any;
  subscriptionCanceledAt?: string | null;
  hasWebflowMapping: boolean;
  wwrCompanyStatement: string;
  wwrCompanyBio: string;
  plan: string;
  careersPages: CareersPage[];
  flipperId: string;
  flipperGroup: string;
  careersPageUrl: string;
  careersPageSlug: string;
  settings: OrganizationSettings;
  users: any;
  organizationUsers: any[];
  ownerId: number;
  hasWebflowAuthentication: boolean;
  webflowIntegration: any;
  hasSlackAuthentication: boolean;
  slackChannelIntegration: any;
  hasDiscordAuthentication: boolean;
  discordChannelIntegration: any;
  zapierApiKey: string;
  linkedinCompanyId: number;
  enabledLinkedinBasicJobs: boolean;
  eligibleForLinkedin: boolean;
  ownerEmailIsCorporate: boolean;
  canEnableLinkedin: boolean;
  enableXHiring: boolean;
  whiteLabelJobBoardEnabled: boolean;
  hudDisplayVisibility: HudDisplayVisibility;
  webflowAuthenticatedViaApiV2: boolean;
  careersPageSubscribersCount: number;
  hiddenJobsCount: number;
  archivedJobsCount: number;
  draftJobsCount: number;
  publishedJobsCount: number;
  hasEverPublishedJob: boolean;
  createdVia: string;
  whatjobsCompanyDescription: string | null;
  eligibleForFreeTrial: boolean;
}

interface CareersPage {
  id: number;
  slug: string;
  additionalContent: string;
  hasCustomNavigation: boolean;
  customNavigationUrl: string;
  logoVisibility: string;
  showPublishedAtTimes: boolean;
  socialShareImageType: string;
  hasLogo: boolean;
  logoFilename: string;
  logoMedium: string;
  socialShareImageUrl: string;
  socialShareImageFilename: string;
  hasSocialShareImage: boolean;
  billboardTitle: string;
  billboardIntro: string;
  billboardVideoUrl: string;
  billboardImageUrl: string;
  previewBillboardImageUrl: string;
  billboardImageFilename: string;
  hasBillboardImage: boolean;
  billboardMediaType: string;
  customDomain: string;
  hasFavicon: boolean;
  faviconFilename: string;
  faviconUrl: string;
  showFilters: boolean;
}

export enum HudDisplayVisibility {
  ALL_MEMBERS = "all_members",
  ADMINS_ONLY = "admins_only",
  HIDDEN = "hidden",
}

export enum Plans {
  NO_PLAN = "plan_no_plan",
  SIMPLE_ATS_FREE = "plan_simple_ats_free",
  SIMPLE_ATS_PAID = "plan_simple_ats_paid",
  SIMPLE_ATS_PER_JOB = "plan_simple_ats_per_job",
  ATS_TIER_FREE = "plan_ats_tier_free",
  ATS_TIER_FREE_V2 = "plan_ats_tier_free_v2",
  ATS_TIER_APOLLO = "plan_ats_tier_apollo",
  ATS_TIER_STARTER = "plan_ats_tier_starter",
  ATS_TIER_GROWTH = "plan_ats_tier_growth",
  ATS_TIER_SCALE = "plan_ats_tier_scale",
  ATS_TIER_ENTERPRISE = "plan_ats_tier_enterprise",
}

export enum PlanFeatures {
  CANDIDATE_MESSAGING = "candidate_messaging",
  CUSTOM_DOMAIN = "custom_domain",
  CUSTOM_CONFIRMATION_EMAILS = "custom_application_confirmation_emails",
  IMPORT_CANDIDATES = "import_candidates",
  LINKEDIN_FEED = "linkedin_feed",
  SLACK_INTEGRATION = "slack_integration",
  DISCORD_INTEGRATION = "discord_integration",
  GOOGLE_JOBS_INTEGRATION = "google_jobs_integration",
  HIRING_STAGE_MESSAGE_AUTOMATIONS = "hiring_stage_message_automations",
  BULK_MOVE = "bulk_move_candidates",
  BULK_MESSAGE = "bulk_message_candidates",
  X_HIRING_FEED = "x_hiring_feed",
  REQUEST_REVIEW = "request_review",
  INTERVIEWER_ROLE = "assign_interviewer_role",
  WHITE_LABEL_JOB_BOARD = "white_label_job_board",
  AI_APPLICANT_SUMMARY = "ai_applicant_summary",
  BULK_RESUME_EXPORT = "bulk_resume_export",
}
